export function stickyHeader() {
    const body = document.body;
    const header = document.querySelector('.header');
    const scrollThreshold = 0;
    let lastScroll = 0;
    let ticking = false;

    if (!header) {
        return;
    }

    function updateState() {
        const scrollY = window.scrollY;

        header.classList.toggle('sticky', scrollY > scrollThreshold);
        //
        // if (scrollY === 0) {
        //     body.classList.remove('up', 'down');
        // } else if (scrollY > lastScroll) {
        //     if (!body.classList.contains('down')) {
        //         body.classList.remove('up');
        //         body.classList.add('down');
        //     }
        // } else {
        //     if (!body.classList.contains('up')) {
        //         body.classList.remove('down');
        //         body.classList.add('up');
        //     }
        // }

        lastScroll = scrollY;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateState();
                ticking = false;
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', updateState);
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js